import { useState } from "react";
import { Button, Dialog, Input, toast } from "../ui";
import { discussionsApi, errMessage } from "./api";
import "./NewTopicDialog.css";

const TITLE_MIN = 3;

export default function NewTopicDialog({ open, onOpenChange, onCreated }) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const reset = () => {
    setTitle("");
    setDescription("");
  };

  const close = (next) => {
    if (!next) reset();
    onOpenChange(next);
  };

  const titleShort = title.trim().length > 0 && title.trim().length < TITLE_MIN;
  const valid = title.trim().length >= TITLE_MIN;

  const submit = async () => {
    if (!valid || submitting) return;
    setSubmitting(true);
    try {
      const topic = await discussionsApi.createTopic({
        title: title.trim(),
        description: description.trim() || null,
      });
      toast.success("Topic created.");
      reset();
      onOpenChange(false);
      if (onCreated) onCreated(topic);
    } catch (e) {
      toast.error(errMessage(e));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onOpenChange={close}
      title="Start a new topic"
      className="vdsc-newtopic"
      footer={
        <>
          <Button variant="secondary" onClick={() => close(false)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={submit}
            loading={submitting}
            disabled={!valid}
          >
            Create topic
          </Button>
        </>
      }
    >
      <Input
        label="Title"
        placeholder="What is this conversation about?"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        error={titleShort ? `At least ${TITLE_MIN} characters required` : undefined}
        maxLength={160}
      />

      <div className="vdsc-field">
        <label className="vdsc-label" htmlFor="vdsc-newtopic-desc">
          Description <span className="vdsc-label-opt">(optional)</span>
        </label>
        <textarea
          id="vdsc-newtopic-desc"
          className="vdsc-textarea"
          rows={4}
          placeholder="Add any context to kick off the discussion."
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </div>
    </Dialog>
  );
}
